import { canCallApp } from '../utils.js';
import { toggleAtcChat } from '../chat.js';
import { delegateListener } from './delegate-listener.js';
import { EventBusSingleton } from './event-bus-singleton.js';

const eventBus = EventBusSingleton.getInstance();

const setDrawers = () => {
    const drawerToggleSelector = '[data-toggle="drawer"]';
    delegateListener('click', drawerToggleSelector, e => {
        if (e.target.closest('[data-prevent-drawer="true"]')) {
            return;
        }
        const btn = e.target.closest(drawerToggleSelector);
        const template = document.querySelector(`template${btn.dataset.target}`);
        if (template) { //Check if the drawers exists
            const nativeAppFunc = template.dataset.nativeAppCall; //Check if there is an app native call for the drawer
            const nativeAppParams = template.dataset.nativeAppParams; //Check if there are parameters for the native func
            e.preventDefault();
            if (nativeAppFunc && canCallApp(nativeAppFunc)) { //Open native app drawer
                Trendier[nativeAppFunc](nativeAppParams ? nativeAppParams : '');
            } else { //Open web drawer
                const drawer = createAndShowDrawer(template); //Create the drawer in the DOM
                setDismissDrawer(drawer); //Set dismiss events for the drawer
            }
        }
    });
};

const createAndShowDrawer = (template) => {
    const drawerNode = template.content.firstElementChild.cloneNode(true); //Get the drawer from the template
    const drawer = document.body.appendChild(drawerNode); //Add the drawer to the DOM
    setTimeout(() => drawer.classList.add('show'), 0); //Wait for the drawer to append
    toggleAtcChat();
    const event = new CustomEvent('show-drawer', { detail: { id: template.id } });
    document.dispatchEvent(event);
    eventBus.publish("createAndShowDrawer", {}, template.id);
    return drawer;
};

const setDismissDrawer = (drawer) => {
    drawer.addEventListener('click', (e) => {
        if (e.target === drawer || e.target.dataset.dismiss === 'drawer') { // Dismiss drawer when clicking outside its body or its dismiss buttons
            dismissDrawer(drawer);
        }
        if (e.target.dataset.dismiss === 'drawers') {
            document.querySelectorAll('.drawer.show').forEach(drawer => dismissDrawer(drawer));
        }
    });
};

const dismissDrawer = (drawer) => {
    const drawerClass = drawer.classList[1];
    if (drawerClass) {
        const eventDismissDrawer = new CustomEvent('dismiss-drawer',
            { detail: { drawerClass: drawerClass } });
        document.dispatchEvent(eventDismissDrawer);
    }
    drawer.classList.remove('show'); //Hide the drawer
    toggleAtcChat();
    setTimeout(() => drawer.remove(), 300); //Wait for the css transitions to end before removing it
};

export { setDrawers, dismissDrawer };